import { render, staticRenderFns } from "./RcvPL.vue?vue&type=template&id=04d8fdfa"
import script from "./RcvPL.vue?vue&type=script&lang=js"
export * from "./RcvPL.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports